import React from "react";
import { Outlet } from "react-router-dom";
import TopStepper from "./components/TopStepper";
import "./CandidateProf.css";

const LeftSection = () => {
  return (
    <div className="leftSectionWrapper">
      <div className="flex flex-col md:flex-row leftSectionMain">
        {/* Horizontal Stepper for mobile */}
        <div className="md:hidden w-full py-4 px-3 bg-mainBg items-center">
          <div className="text-center mb-3">
            <div className="text-xl font-medium text-center mb-2">Complete your profile!👋</div>
            <h6>
              Unlock 500+ jobs from top companies and
              <br /> receive direct calls from HRs
            </h6>

          </div>
          <TopStepper orientation="horizontal" />
        </div>

        {/* Sidebar for larger screens */}
        <div className="hidden md:flex fixed leftSectionLeft bg-mainBg px-6 py-10 h-screen flex-col justify-around">
          <div>
            <div className="flex flex-col justify-around">
              <h5 className="text-3xl">Complete your profile!👋</h5>
              <h6>
                Unlock 500+ jobs from top companies and
                <br /> receive direct calls from HRs
              </h6>
            </div>

            <div className="my-5">
              <TopStepper orientation="vertical" />
            </div>
          </div>
        </div>

        {/* Main content area */}
        <div className="w-full md:w-2/3 candidate-outlet px-4 md:px-10 outletScrollable">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LeftSection;